import React, { useEffect } from 'react';
import { Header, Footer } from '../../component/index';
import MediaQuery from 'react-responsive';
import { getCountries, useInput, validate } from '../../helper';
import { useLocaleContext } from '../../component/AppProvider/LocaleProvider';

const Freetrial = () => {
    const [ locale ] = useLocaleContext()
    const [ countries, setCountries] = React.useState()
    const [ selectedCountry, setSelectedCountry ] = React.useState()
    const [ sendMail, setSendMail ] = React.useState('')
    const { value:company, bind:bindCompany } = useInput('')
    const { value:name, bind:bindName } = useInput('')
    // const { value:tel, bind:bindTel } = useInput('')
    // const { value:ext, bind:bindExt} = useInput('')
    const { value:phone, bind:bindPhone } = useInput('')
    const { value:email, bind:bindEmail } = useInput('')
    const { value:address, bind:bindAddress } = useInput('')
    const { value:employee, bind:bindEmployee } = useInput('')
    const { value:code, bind:bindCode } = useInput('')
    
    useEffect(() => {
        (async function() {
            try {
                const countries = await getCountries()
                if(countries) setCountries(countries)
            } catch (e) {
                console.error(e);
            }
        })();
    }, [])
    
    const handleChange = (event) => {
        const selectedValue = event.target.value
        const sendMail = countries.find( each => { return each.nSubject === selectedValue }).nContent
        setSelectedCountry(selectedValue)
        setSendMail(sendMail)
    }
    
    const changeCode = (event) => {
        event.target.src = "http://www.worldcardteam.com/en/CAPTCHA.ashx?r=" + Math.random();
    }

    const send = () => {
        if(!validate()) return
        // let url = process.env.REACT_APP_BASE_URL + 'api/trial'
        let url = 'http://localhost:18190/api/trial'

        fetch(url, { 
            method: 'POST', 
            body: JSON.stringify({
                contCompany: company,
                contName: name,
                contMobile: phone,
                contEmail: email,
                contCountry: selectedCountry,
                contSendMail: sendMail,
                contAdd: address,
                contEmployee: employee
            }),
            headers: {
                'Content-Type': 'application/json',
                locale: locale
            }
        })
        .then(result => { return result.json() })
        .then(result => console.log(result))
        .catch(error => console.error(error))
    }

    return (
        <>
        <Header homepage={false}/>
        <div className="wrapper">
            <div className="container-w-lg">
                <div className="row">
                    <img className="features-img" src="static/images/img_bg_Free-trial.png" alt="features" width="100%" />
                    <MediaQuery minWidth={992}>
                        <div className="left-control col-4">
                            <h1 className="item-title">Free Trial</h1>
                            <p className="item-content">Please fill out the form below and we will contact you as soon as possible.</p>
                        </div>
                        <div className="right-control col-5">
                            <form role="form" className="freetrial-form" autoComplete="off">
                                <div className="form-row">
                                    <div className="form-group col-sm-7">
                                        <input type="text" className="form-control" placeholder="Company" {...bindCompany} required />
                                    </div>
                                    <div className="form-group col-sm-5">
                                        <input type="text" className="form-control" placeholder="Name" {...bindName} required/>
                                    </div>
                                </div>
                                <div className="form-row">
                                    {/* <div className="form-group col-sm-5">
                                        <input type="text" className="form-control" placeholder="Tel" {...bindTel} />
                                    </div>
                                    <div className="form-group col-sm-2">
                                        <input type="text" className="form-control" placeholder="Ext" {...bindExt} />
                                    </div> */}
                                    <div className="form-group col-sm-12">
                                        <input type="text" className="form-control" placeholder="Phone" {...bindPhone}  required/>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <input type="text" className="form-control" placeholder="Email" {...bindEmail}  required/>
                                </div>
                                <div className="form-row">
                                    <div className="form-group col-sm-5">
                                        <select className="form-control custom-select" onChange={handleChange} required>
                                            <option value="">Please Select Country</option>
                                            {   
                                                countries && countries.map( each => {
                                                    return <option key={each.nSubject} value={each.nSubject}>{each.nSubject}</option> 
                                                })
                                            }
                                        </select>
                                    </div>
                                    <div className="form-group col-sm-7">
                                        <input type="text" className="form-control" placeholder="Address" {...bindAddress} required/>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <input type="text" className="form-control" placeholder="Number of Employee" {...bindEmployee} required/>
                                </div>
                                <div className="form-group validate">
                                    <input type="text" className="form-control" placeholder="Verification Code" {...bindCode} required/>
                                    <img src="http://www.worldcardteam.com/en/CAPTCHA.ashx" alt="Validate Code" id="validateCode" onClick={changeCode}/>
                                </div>
                            </form>
                            <div className="form-group">
                                <button className="btn btn-block btn-primary radius-0" onClick={send}>Send</button>
                            </div>
                        </div>
                    </MediaQuery>
                    <MediaQuery maxWidth={991}>
                        <div className="left-control justify-content-center">
                            <h1 className="item-title text-center">Free Trial</h1>
                            <p className="item-content text-center">Please fill out the form below and we will contact you as soon as possible.</p>
                        </div>
                        <div className="right-control justify-content-center">
                            <form role="form" className="freetrial-form" autoComplete="off">
                                <div className="form-row">
                                    <div className="form-group col-sm-7">
                                        <input type="text" className="form-control" placeholder="Company" {...bindCompany} required/>
                                    </div>
                                    <div className="form-group col-sm-5">
                                        <input type="text" className="form-control" placeholder="Name" {...bindName} required/>
                                    </div>
                                </div>
                                <div className="form-row">
                                    {/* <div className="form-group col-sm-5">
                                        <input type="text" className="form-control" placeholder="Tel" {...bindTel} />
                                    </div>
                                    <div className="form-group col-sm-2">
                                        <input type="text" className="form-control" placeholder="Ext" {...bindExt} />
                                    </div> */}
                                    <div className="form-group col-sm-12">
                                        <input type="text" className="form-control" placeholder="Phone" {...bindPhone} required/>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <input type="text" className="form-control" placeholder="Email" {...bindEmail} required/>
                                </div>
                                <div className="form-row">
                                    <div className="form-group col-sm-5">
                                        <select className="form-control custom-select" onChange={handleChange} required>
                                            <option value="">Please Select Country</option>
                                            {   
                                                countries && countries.map( each => {
                                                    return <option key={each.nSubject} value={each.nSubject}>{each.nSubject}</option> 
                                                })
                                            }
                                        </select>
                                    </div>
                                    <div className="form-group col-sm-7">
                                        <input type="text" className="form-control" placeholder="Address" {...bindAddress} required/>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <input type="text" className="form-control" placeholder="Number of Employee" {...bindEmployee} required/>
                                </div>
                                <div className="form-group validate">
                                    <input type="text" className="form-control" placeholder="Verification Code" {...bindCode} required/>
                                    <img src="http://www.worldcardteam.com/en/CAPTCHA.ashx" alt="Validate Code" id="validateCode" onClick={changeCode}/>
                                </div>
                            </form>
                            <div className="form-group">
                                <button type="submit" className="btn btn-block btn-primary radius-0" onClick={send}>Send</button>
                            </div>
                        </div>
                    </MediaQuery>
                </div>
            </div>
            <div className="above-footer"></div>
        </div>
        <Footer/>
        </>
    )
}

export default Freetrial;